import PropTypes from "prop-types";
import content from "app-content";
import ProgressIndicatorWrapper from "../ProgressIndicatorWrapper";
import styles from "./index.css";
import UniversalMain from "../../../../../universal/components/presentational/Main";

const Main = ({ loadingDataOnPageLoad, EntryPoint }) => (
  <UniversalMain className={styles.main}>
    <ProgressIndicatorWrapper
      whenInProgressMessage={
        content.saved_items_accessibility_page_loading_placeholders
      }
      isInProgress={loadingDataOnPageLoad === true}
      invisibleOverlayClassName={styles.invisibleProgressOverlay}
    >
      <EntryPoint loadingDataOnPageLoad={loadingDataOnPageLoad} />
    </ProgressIndicatorWrapper>
  </UniversalMain>
);

Main.propTypes = {
  loadingDataOnPageLoad: PropTypes.bool,
  EntryPoint: PropTypes.elementType.isRequired
};

export default Main;
